export const preactWidget = (widget) => {
  const $root = document.getElementById(widget.htmlId);
  const props = {
    htmlProps: getHtmlProps($root),
    widget,
  };
  $root.innerHTML = '';
  return { $root, props };
};

export const preactMultipleWidgets = (widget) => {
  return Array.from(document.querySelectorAll(widget.selector)).map(($root) => {
    const props = {
      htmlProps: getHtmlProps($root),
      widget,
    };
    $root.innerHTML = '';
    $root.setAttribute('data-initialized', true);
    return { $root, props };
  });
};

function getHtmlProps($root) {
  const dataJson = $root.dataset?.json;
  return dataJson ? JSON.parse(dataJson) : {};
}
